import loadable from '@loadable/component';

export const SaveSearchModalContainerLoadable = loadable(() => import('./SaveSearchModalContainer'), {
  resolveComponent: ({ SaveSearchModalContainer }) => SaveSearchModalContainer,
});
